import React, { useRef, useContext } from "react";
import CharacterLoader from "./PopChild/Character";
import MyContext from "../../context/MyContext";
const PreviewCharacter = ({
  setLoadCounter,
  value,
  TickerStart,
  isAnimatedText,
  SlidesData,
  setSlidesData,
  TickerPosition,
  TickerRef,
  zInd,
  CanvasDisplay,
  index,
  onePX,
  SupremeLayer,
}) => {
  const CharRef = useRef(null);
  const { EditorZoom } = useContext(MyContext);

  return (
    <>
      <div
        className={"changer EditStart " + value.InClass + value.OutClass}
        id={"Preview-" + value.AnimationId}
        style={{
          VendorAnimationDuration: ".5s",
          transform: `rotate(${value.rotateAngle}deg) ` + value.flip ,
          display: !CanvasDisplay
            ? value.player
              ? "inline-block"
              : "none"
            : TickerStart
            ? value.startPositionOnTimeline <= TickerPosition &&
              value.startPositionOnTimeline + value.widthOnTimeline >=
                TickerPosition
              ? "inline-block"
              : "none"
            : value.startPositionOnTimeline + value.startTransitionWidth <=
                TickerPosition &&
              value.startPositionOnTimeline +
                value.widthOnTimeline -
                value.startTransitionWidth >=
                TickerPosition
            ? "inline-block"
            : "none",
          height: value.height,
          width: value.width,
          zIndex: zInd,
          left: value.x,
          top: value.y,
        }}
        ref={CharRef}
      >
        <CharacterLoader
          key={`CharacterLoader${index}`}
          isAnimatedText={isAnimatedText}
          value={value}
          player={value.Animate}
          ticker={TickerPosition}
          TickerRef={TickerRef}
          AnimationId={value.AnimationId + "inPreview"}
          CanvasDisplay={CanvasDisplay}
          onePxEquivalent={onePX}
          setLoadCounter={setLoadCounter}
          SlidesData={SlidesData}
          setSlidesData={setSlidesData}
        />
      </div>
    </>
  );
};

export default PreviewCharacter;
